import React from 'react';
import './CTASection.css';

interface CTASectionProps {
  title: string;
  subtitle: string;
  buttonText?: string;
  buttonEmoji?: string;
  onButtonClick: () => void;
  textColor?: 'light' | 'dark';
}

const CTASection: React.FC<CTASectionProps> = ({
  title,
  subtitle,
  buttonText = 'Call Our Party Director',
  buttonEmoji,
  onButtonClick,
  textColor = 'dark'
}) => {
  return (
    <div className={`cta-content ${textColor === 'light' ? 'light-text' : 'dark-text'}`}>
      <h2>{title}</h2>
      <p className="themes-description">{subtitle}</p>
      <button className={`cta-button large ${textColor === 'light' ? 'dark-text' : 'light-text'}`} onClick={onButtonClick}>
        {buttonEmoji && <span className="button-emoji">{buttonEmoji}</span>}
        {buttonText}
      </button>
    </div>
  );
};

export default CTASection;
